<!--<span (click)="savetoWatchList()" class="add-to-watchlist" #anchor (click)="show = !show">-->
<span (click)="savetoWatchList()" class="add-to-watchlist" #anchor>
  <span class="inline-loader loader-xs loader blue" [hidden]="!loadingList"></span>
  <span [hidden]="loadingList || !stockCode">
    <img *ngIf="!selectedAsWatchList" [src]="'../assets/images/research-portal/icons/heart' + (darkMode ? '-dark' : '') + '.png'" />
    <img *ngIf="selectedAsWatchList" [src]="'../assets/images/research-portal/icons/heart-active.png'" class="active" />
  </span>
</span>
<span class="company-alert d-none">
  <img [src]="'../assets/images/research-portal/icons/bell-plus' + (darkMode ? '-dark' : '') + '.png'"
/></span>

<!-- <kendo-popup
  [popupAlign]="popupAlign"
  [anchorAlign]="anchorAlign"
  [positionMode]="'absolute'"
  [anchor]="anchor"
  [hidden]="!show"
>
  <div class='' *ngIf='!selectedAsWatchList'>
    <div>
      <span>Add this Stock to your watchlist?</span>
    </div>
    <div class='float-end mt-1'>
      <button class='yes-btn' (click)='addToWatchList()'>Yes</button>
      <button class='no-btn' (click)='show = !show'>No</button>
    </div>
  </div>
  <div class='' *ngIf='selectedAsWatchList'>
    <div>
      <span>Remove this Stock from your watchlist?</span>
    </div>
    <div class='float-end mt-1'>
      <button class='yes-btn' (click)='removeItemFromWatchList(selectedAsWatchList?.id)'>Yes</button>
      <button class='no-btn' (click)='show = !show'>No</button>
    </div>
  </div>
</kendo-popup> -->
